import React from 'react';
import { Button } from '../../../ui';
import priceCurrency from './priceCurrency.json';

const SmartInvestment = ({ currency }) => {
  return (
    <div className="bg-cover bg-no-repeat bg-smartInvestment relative flex items-center justify-center">
      <img
        src="https://admin.weprodigi.com/uploads/images/seo/vector-left-1.png"
        className={'animated-image absolute z-10 -left-[160px] md:left-0 md:h-[217px] h-[300px]'}
        alt="vector-left-1"
      />
      <img
        src="https://admin.weprodigi.com/uploads/images/seo/vector-left-2.png"
        className={'animated-image2 absolute z-10 -left-[160px] md:left-0 md:h-[217px] h-[300px]'}
        alt="vector-left-2"
      />
      <div className="container py-[98px] md:py-[30px] ">
        <div className="flex flex-col items-center justify-center relative z-20 gap-[20px]">
          <h4
            className={'max-w-[344px] md:max-w-[680px] font-[600] text-center text-[24px] md:text-[34px] leading-[30px] md:leading-[41px] text-black'}
          >
            Your Smart Investment Starts at <span className=" text-white">{priceCurrency[currency]} </span>Grow with Confidence
          </h4>
          <a href={`/seo/seo-form`}>
            <Button variant="primary" narrowing="both" mode="light">
              Get your free SEO plan
            </Button>
          </a>
        </div>
      </div>
      <img
        src="https://admin.weprodigi.com/uploads/images/seo/vector-right-1.png"
        className={'animated-image2 absolute z-10 -right-[160px] md:right-0  md:h-[217px] h-[300px]'}
        alt="vector-right-1"
      />
      <img
        src="https://admin.weprodigi.com/uploads/images/seo/vector-right-2.png"
        className={'animated-image absolute z-10 -right-[160px] md:right-0 md:h-[217px] h-[300px]'}
        alt="vector-right-2"
      />
    </div>
  );
};

export default SmartInvestment;
